import type { SwapAggregatorDAO } from "./types"

const FLY_MAGPIE: SwapAggregatorDAO = {
  id: "fly",
  name: "Fly",
  description: "Fast and secure cross-chain bridge aggregator",
  icon: "/brands/fly-icon.svg",
  logoUrl: "https://magpieprotocol.io/assets/images/logo.png",
  isProductionReady: true,
  isActive: true,
}

const KYBER: SwapAggregatorDAO = {
  id: "kyber",
  name: "KyberSwap",
  description: "Reliable multi-source DEX aggregator with superior routing",
  icon: "/brands/kyber-icon.svg",
  logoUrl: "https://kyber.network/media-kit?lang=en",
  isProductionReady: true,
  isActive: true,
}

const OPENOCEAN: SwapAggregatorDAO = {
  id: "openocean",
  name: "OpenOcean",
  description: "Cross-chain DEX aggregator with competitive rates",
  icon: "/brands/openocean-icon.svg",
  logoUrl: "https://openocean.finance/images/logo.svg",
  isProductionReady: true,
  isActive: false,
}

export const staticAggregators: Array<SwapAggregatorDAO> = [FLY_MAGPIE, KYBER, OPENOCEAN]
